<template>
  <div class="bigEvent activity" :class="{floating: !inplace}"
       :style="inplace ? {} : {left: activity.position.left + 'px', top: activity.position.top + 'px'}">
    <div class="event-header">
      <span class="event-date">{{ activity.datetime.date() }} <template v-if="$mq == 'sm'">({{ activity.datetime.format('ddd')}})</template></span>
      <span class="event-name">AKTYWNOŚĆ</span>
      <span class="event-actions">
        <v-icon dark class="click-effect" v-if="isActiveRunner" v-tooltip="'Edytuj'" @click.stop="$emit('edit-activity')">edit</v-icon>
        <v-icon dark class="click-effect" v-if="isActiveRunner" v-tooltip="'Usuń'" @click.stop="$emit('remove-activity')">delete</v-icon>
        <v-icon dark class="click-effect ml-2" v-if="!inplace" v-tooltip="'Zamknij'" @click.stop="$emit('close')">close</v-icon>
      </span>
    </div>
    <div class="event-content">
      <div class="event-content__header">
        Wykonana aktywność
        <v-icon class="click-effect" v-if="isActiveRunner" v-tooltip="'Edytuj aktywność'" @click.stop="$emit('edit-activity')">edit</v-icon>
      </div>
      <ul>
        <li>
          <TextField label="Opis" pre>
            <i slot="prepend" v-tooltip="'Opis'" class="text-icon">O</i>{{activity.runner_additional_info }}
          </TextField>
        </li>
        <li>
          <TextField label="Dystans">
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1"></i>
            {{activity.total_distance_done }}
          </TextField>
        </li>
      </ul>
    </div>
    <div class="event-footer">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextField from '@/utils/TextField'

export default {
  components: {TextField},
  props: {
    activity: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['runner', 'isActiveRunnerTrainer', 'isActiveRunner'])
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/ActivityBig.vue